import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { WorkScheduleSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/work-schedule/_layout/shifts/')({
  validateSearch: zodValidator(WorkScheduleSearchSchema)
});